module.exports = __webpack_public_path__ + "static/img/twjd-sde11.1c4e0fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde11.png
// module id = 97
// module chunks = 0